var site = site || {};

(function ($) {
  Drupal.behaviors.MPPWaypoints = {
    attach: function (context) {
      if (this.attached) {
        return;
      }
      this.attached = true;

      var $stickyHeader = $('.js-site-header-sticky', context);
      var $filters = $('.mpp__filters', context);
      var $triggers = $('.mpp__filters__trigger', context);
      var $collapseButton = $triggers.find('.icon.icon-arrow_down');
      var $mppHeader = $('.mpp .page-header, .node-elc-mpp .page-header', context);
      var $filterLinks = $('.js-filter-trigger', context);
      var $summary = $('.mpp__filters__summary', context);
      var $summaryText = $('.mpp__filters__summary-text', $summary);
      var $mixItUpEl = $('.mpp .js-filterable-items-wrapper', context);
      var st = $(window).scrollTop();
      var offset = 0;
      var $skuCardContainer = $('.js-sku-card', context);

      // To determine if the filters section is collapsed
      function determineCollapsed() {
        if ($triggers.hasClass('active')) {
          $collapseButton.attr('aria-expanded', 'false');
        } else {
          $collapseButton.attr('aria-expanded', 'true');
        }
      }

      function _setOffset() {
        if ($stickyHeader.css('position') === 'fixed') {
          offset = $stickyHeader.outerHeight(true);
          $filters.css('top', offset);
        } else {
          offset = 0;
        }
      }

      function enableSkuCards() {
        $skuCardContainer.each(function () {
          var $this = $(this);
          var shade = $this.data('shade-name');

          // removing shade numbers (skin foundation shades)
          if (shade) {
            shade = shade.replace(/[0-9.() ]+$/g, '');
            var shadeName = shade.split(' ').join('_');
            var $anchorLink = $this.find('.js-sku-image-link');

            $anchorLink.each(function () {
              var $thisLink = $(this);
              var oldLink = $thisLink.attr('href');
              var newLink = oldLink + '#/shade/' + shadeName;

              $thisLink.attr('href', newLink);
            });
          }
        });
      }

      // Collapse filters by default on mobile
      function _collapseMobile() {
        if (Unison.fetch.now() && Unison.fetch.now().name === 'small') {
          $filters.addClass('mpp__filters--collapsed');
          $triggers.addClass('active');
        }
      }

      $mixItUpEl.on('mixEnd', function () {
        var filterText = [];

        $filterLinks.filter('.active').each(function () {
          filterText.push($(this).text());
        });
        $summaryText.text(filterText.join(', '));
        $summary.toggleClass('mpp__filters__summary--empty', !filterText.length);
      });

      $triggers.on('click', function (event) {
        event.preventDefault();
        $filters.toggleClass('mpp__filters--collapsed');
        $(this).toggleClass('active');
        determineCollapsed();
      });

      // Keydown event for collapse button
      $triggers.on('keydown', function (event) {
        if (site.getKeycode(event) === 13) {
          $(this).trigger('click');
        }
      });

      if ($mppHeader.length && $filters.length) {
        $(window).on('scroll', function () {
          var nst = $(window).scrollTop();
          var down = nst > st;
          var headerBottom = $mppHeader.offset().top + $mppHeader.outerHeight(false);

          if (nst >= headerBottom && st < headerBottom || nst < headerBottom && st >= headerBottom) {
            _setOffset();
            var mb = down ? $filters.outerHeight(false) : 0;

            $mppHeader.css('marginBottom', mb);
            $filters.toggleClass('mpp__filters--sticky mpp__filters--collapsed', down);
            $triggers.toggleClass('active', down);
          }
          st = nst;
          determineCollapsed();
        });
      }

      $(window).on('checked-utility-links', function () {
        _setOffset();
      });

      Unison.on('change', _collapseMobile);

      $(document).on('check-layout', function () {
        _setOffset();
      });
      $(window).on('load', function () {
        _setOffset();
        determineCollapsed();
      });

      _collapseMobile();

      // this will be executed only when sku card is enabled in CMS
      if ($skuCardContainer.length > 0) {
        enableSkuCards();
      }
    },
    attached: false
  };
})(jQuery);
